import { updateBannerCountsFromScan } from 'src/composables/banner/query/cache-handlers'
import { syncScanHistoryFromStatus } from 'src/composables/scans/query/useScanHistoryCache'
import { QUERY_KEYS } from 'src/services/consts/queries.const'

/**
 * Processes a classification PATCH response into all relevant caches.
 * Used by both the originating mutation and the broadcast receiver.
 *
 * @param {import('@tanstack/vue-query').QueryClient} queryClient
 * @param {string} siteId
 * @param {import('src/services/helpers/scan/status.helper').ScanResults} updatedResults
 */
export function applyScanCategoryOverride(queryClient, siteId, updatedResults) {
  if (!siteId || !updatedResults) return

  const previousScanStatus = queryClient.getQueryData([QUERY_KEYS.SCAN_STATUS, siteId])
  if (previousScanStatus) {
    const scanStatus = { ...previousScanStatus, results: updatedResults }
    queryClient.setQueryData([QUERY_KEYS.SCAN_STATUS, siteId], scanStatus)
    syncScanHistoryFromStatus(queryClient, siteId, scanStatus)
  }

  updateBannerCountsFromScan(queryClient, siteId, updatedResults.summary)
}
